module.exports = __webpack_public_path__ + "img/companyImg1.31ed6bc9.jpg";